module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#user-square",
      toString: function () {
        return this.url;
      }
    }